// React imports
import { useEffect, useState } from "react";

// Material UI imports
import { MenuItem, SelectProps, Stack } from "@mui/material";

// ERP Common imports
import {
  ArrowCircleDown,
  Calendar,
  CheckboxSquare,
  Clock,
  DollarCircle,
  Email,
  Grid,
  Hashtag,
  Image,
  InfoCircle,
  Link,
  LinkHorizontal,
  Location,
  PaperClip,
  Paragraph,
  Phone,
  RadioButton,
  ToggleSwitch,
} from "@/components/icons";
import Select from "@/components/select/select";
import Typography from "@/components/typography/typography";

interface IField {
  label: string;
  value: string;
  icon: typeof Paragraph | string;
}

const fields: IField[] = [
  { label: "Text", value: "text", icon: Paragraph },
  { label: "Number", value: "number", icon: Hashtag },
  { label: "Select", value: "select", icon: ArrowCircleDown },
  { label: "Date", value: "date", icon: Calendar },
  { label: "Files & Media", value: "file", icon: PaperClip },
  { label: "URL", value: "url", icon: Link },
  { label: "Email", value: "email", icon: Email },
  { label: "Phone", value: "phone", icon: Phone },
  { label: "Currency", value: "currency", icon: DollarCircle },
  { label: "Time", value: "time", icon: Clock },
  { label: "Table", value: "table", icon: Grid },
  { label: "Geolocation", value: "geoLocation", icon: Location },
  { label: "Check Box", value: "checkbox", icon: CheckboxSquare },
  { label: "Image Upload", value: "image", icon: Image },
  { label: "Relation Field", value: "relation", icon: LinkHorizontal },
  { label: "Info Card", value: "info", icon: InfoCircle },
  { label: "Toggle Button", value: "toggleButton", icon: ToggleSwitch },
  { label: "Radio Button", value: "radioButton", icon: RadioButton },
  { label: "tagsInput", value: "tagsInput", icon: Paragraph },
];

const FieldSelect: React.FC<SelectProps> = (props) => {
  const [selectFields, setSelectFields] = useState<IField[]>(fields);
  const [search, setSearch] = useState<string>("");

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const handleSearchFields = (searchVal: string) => {
    if (searchVal) {
      setSelectFields([
        ...fields.filter((field) => field.value.includes(searchVal)),
      ]);
    } else {
      setSelectFields(fields);
    }
  };

  useEffect(() => {
    handleSearchFields(search);
  }, [search]);

  return (
    <Select
      fullWidth
      placeholder="Select Field"
      size="small"
      labelName="Field Type"
      renderValue={(value: string) =>
        fields.find((field) => field.value === value)?.label
      }
      handleSearch={() => handleSearch}
      searchPlaceholder="Search Attributes"
      searchValue={search}
      {...props}
    >
      {selectFields.map((field) => (
        <MenuItem value={field.value} onKeyDown={(e) => e.stopPropagation()}>
          <Stack direction="row" spacing={1} alignItems="center">
            {field.icon && <field.icon fontSize="small" />}
            <Typography type="s3" color="theme.secondary.1000">
              {field.label}
            </Typography>
          </Stack>
        </MenuItem>
      ))}
    </Select>
  );
};

export default FieldSelect;
